"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../utils");
var _ = require("../..");
var _styled = require("../../base/styled");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CompanyBanner = function CompanyBanner(_ref) {
  var _company$headquarterL, _company$headquarterL2, _company$headquarterL3, _company$headquarterL4, _company$headquarterL5, _company$headquarterL6, _company$headquarterL7, _company$headquarterL8;
  var company = _ref.company,
    editable = _ref.editable,
    onEditBanner = _ref.onEditBanner,
    onEditLogo = _ref.onEditLogo,
    setEmoji = _ref.setEmoji,
    companyTypes = _ref.companyTypes,
    separatorBand = _ref.separatorBand,
    bannerAndLogoRequired = _ref.bannerAndLogoRequired;
  var industries = (0, _utils.groupIndustriesByVertical)(company.industries);
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, null, /*#__PURE__*/_react.default.createElement(_styled2.ImagesContainer, null, /*#__PURE__*/_react.default.createElement(_.Banner, {
    photo: company === null || company === void 0 ? void 0 : company.photoUrl,
    editable: editable,
    onEdit: onEditBanner
  }), /*#__PURE__*/_react.default.createElement(_.Logo, {
    logo: company === null || company === void 0 ? void 0 : company.logoUrl,
    editable: editable,
    onEdit: onEditLogo
  })), separatorBand && /*#__PURE__*/_react.default.createElement(_styled2.SeparatorBand, null, /*#__PURE__*/_react.default.createElement(_styled2.BandItem, {
    left: true,
    color: "#73DB62"
  }, (0, _utils.getBandName)(company.totalQualifiedFor, 'Qualified')), /*#__PURE__*/_react.default.createElement(_styled2.BandItem, {
    right: true
  }, (0, _utils.getBandName)(company.totalOpportunities, company.totalOpportunities > 1 ? 'Positions' : 'Position'))), bannerAndLogoRequired && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !company.photoUrl && /*#__PURE__*/_react.default.createElement("p", {
    style: {
      color: '#ff3333'
    }
  }, "Banner is required."), !company.logoUrl && /*#__PURE__*/_react.default.createElement("p", {
    style: {
      color: '#ff3333'
    }
  }, "Logo is required.")), /*#__PURE__*/_react.default.createElement(_styled2.CompanyName, null, company.name, " "), setEmoji && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: '24px',
      marginBottom: '8px'
    }
  }, company.emojis), /*#__PURE__*/_react.default.createElement(_styled2.Description, null, company.headquarterLocation && !editable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (_company$headquarterL = company.headquarterLocation) !== null && _company$headquarterL !== void 0 && _company$headquarterL.international ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styled2.Text, null, "International"), /*#__PURE__*/_react.default.createElement(_styled2.Text, null, "".concat((_company$headquarterL2 = company.headquarterLocation) === null || _company$headquarterL2 === void 0 ? void 0 : (_company$headquarterL3 = _company$headquarterL2.country) === null || _company$headquarterL3 === void 0 ? void 0 : _company$headquarterL3.country, ", ").concat((_company$headquarterL4 = company.headquarterLocation) === null || _company$headquarterL4 === void 0 ? void 0 : _company$headquarterL4.cityName))) : /*#__PURE__*/_react.default.createElement(_styled2.Text, null, "US ".concat((_company$headquarterL5 = company.headquarterLocation) === null || _company$headquarterL5 === void 0 ? void 0 : (_company$headquarterL6 = _company$headquarterL5.city) === null || _company$headquarterL6 === void 0 ? void 0 : _company$headquarterL6.city, ", ").concat((_company$headquarterL7 = company.headquarterLocation) === null || _company$headquarterL7 === void 0 ? void 0 : (_company$headquarterL8 = _company$headquarterL7.state) === null || _company$headquarterL8 === void 0 ? void 0 : _company$headquarterL8.name))), !editable && !(0, _isEmpty.default)(industries) && industries.map(function (industry) {
    return /*#__PURE__*/_react.default.createElement(_styled.Row, {
      key: industry,
      $bsStyle: {
        flexWrap: 'wrap',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_styled.Column, null, /*#__PURE__*/_react.default.createElement(_styled2.Text, {
      key: industry.name,
      $bsStyle: {
        marginRight: '10px'
      }
    }, industry.name, ":")), industry.results.map(function (result, index) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: index
      }, index > 0 && /*#__PURE__*/_react.default.createElement(_styled.Column, null, /*#__PURE__*/_react.default.createElement(_styled2.Text, {
        $bsStyle: {
          minWidth: '20px'
        }
      }, "-")), /*#__PURE__*/_react.default.createElement(_styled.Column, null, /*#__PURE__*/_react.default.createElement(_styled2.Text, {
        key: industry.vertical
      }, result.industry)));
    }));
  }), !editable && company.type && /*#__PURE__*/_react.default.createElement(_styled2.Text, null, (0, _utils.getOptionValue)(companyTypes, Number(company.type)))));
};
CompanyBanner.propTypes = {
  onEditBanner: _propTypes.default.func,
  onEditLogo: _propTypes.default.func,
  company: _utils.companyProps.isRequired,
  setEmoji: _propTypes.default.bool,
  separatorBand: _propTypes.default.bool,
  bannerAndLogoRequired: _propTypes.default.bool,
  editable: _propTypes.default.bool,
  companyTypes: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number.isRequired,
    name: _propTypes.default.string.isRequired
  }))
};
CompanyBanner.defaultProps = {
  editable: false,
  setEmoji: false,
  onEditBanner: undefined,
  onEditLogo: undefined,
  separatorBand: false,
  companyTypes: [],
  bannerAndLogoRequired: false
};
var _default = CompanyBanner;
exports.default = _default;